import React from 'react';
import { Icon } from '@iconify/react';
import LoadingSpinner from './LoadingSpinner';

const TableMui = ({
  loading = false,
  th = {},
  td = [],
  customFields = [],
  pagination = false,
  page = 1,
  limit = 10,
  totalResults = 0,
  onPageChange,
}) => {
  const headers = Object.keys(th);
  const totalPages = Math.ceil(totalResults / limit);

  const renderCell = (key, value, row) => {
    const customField = customFields.find(f => f.name === key);
    if (customField && customField.data) {
      return customField.data(value, row);
    }
    return value;
  };

  const handlePrevPage = () => {
    if (page > 1 && onPageChange) {
      onPageChange(null, page - 1);
    }
  };

  const handleNextPage = () => {
    if (page < totalPages && onPageChange) {
      onPageChange(null, page + 1);
    }
  };

  return (
    <div className="w-full">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-border-light">
            <tr>
              {headers.map((key) => (
                <th
                  key={key}
                  className="px-4 py-3 text-left text-xs font-semibold text-text-secondary uppercase"
                >
                  {th[key]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-border-light">
            {loading ? (
              <tr>
                <td colSpan={headers.length} className="px-4 py-12 text-center">
                  <LoadingSpinner size="lg" />
                </td>
              </tr>
            ) : td.length > 0 ? (
              td.map((row, idx) => (
                <tr key={row.id || idx} className="hover:bg-gray-50">
                  {headers.map((key) => (
                    <td key={key} className="px-4 py-3 text-sm text-text-dark">
                      {renderCell(key, row[key], row)}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length} className="px-4 py-12 text-center">
                  <Icon
                    icon="mdi:database-outline"
                    className="mx-auto mb-2 text-4xl text-gray-300"
                  />
                  <p className="text-sm font-semibold text-text-dark">No data found</p>
                  <p className="text-xs text-text-secondary">
                    No results match your current filters
                  </p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {pagination && totalResults > 0 && (
        <div className="flex items-center justify-between px-4 py-4 border-t border-border-light">
          <div className="text-sm text-text-secondary">
            Showing {Math.min((page - 1) * limit + 1, totalResults)} to{' '}
            {Math.min(page * limit, totalResults)} of {totalResults} results
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={handlePrevPage}
              disabled={page <= 1}
              className="px-3 py-2 border border-border-light rounded-lg text-sm font-medium text-text-dark hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Icon icon="mdi:chevron-left" className="text-lg" />
            </button>
            <div className="text-sm text-text-dark">
              Page {page} of {totalPages}
            </div>
            <button
              onClick={handleNextPage}
              disabled={page >= totalPages}
              className="px-3 py-2 border border-border-light rounded-lg text-sm font-medium text-text-dark hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Icon icon="mdi:chevron-right" className="text-lg" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableMui;
